import Component from "../../../js/assets/component.js"
import Device from "../../../js/assets/device.js"
import Header from "../organisms/common_block/header.js"
import TabContent from '../organisms/tab_content_block/tab_content.js'
import DepartureCalendar from '../molecules/departure_calendar/departure_calendar.js'
import AirHotelsSelectBlock from '../organisms/air_hotels_select_block/air_hotels_select_block.js'
import TourDetailReserve from '../organisms/tour_detail_reserve/tour_detail_reserve.js'
import ProductImgSlideShow from '../molecules/product_img_slideshow/product_img_slideshow.js'
import WindowScroll from "../../../js/assets/window_scroll.js"
import TourList from "../organisms/tour_list/tour_list.js"
import TourListAjaxPagination from "../organisms/tour_list/tour_list_ajax_pagination.js"
import OutOfStockAlert from '../molecules/out_of_stock_alert/out_of_stock_alert.js'
import TourContactInformation from '../molecules/tour_contact_information/tour_contact_information.js'
import Participant from '../organisms/participants/participants.js'
import TourDetailConfirmApplication from '../organisms/tour_detail_confirm_application/tour_detail_confirm_application.js'

class Detail extends Component {
  constructor(el){
    super(el)
  }

  data(){
    return {
      "tabContentScrollTop" : null,
      "tabContentBottom" : null,
      "tourDetailContentTop" : null,
      "device_mode" : null
    }
  }

  changed(){
    return {
      "tabContentScrollTop" : (val, prev)=>{

      },
      "tabContentBottom" : (val, prev)=>{

      },
      "tourDetailContentTop" : (val, prev)=>{

      },
      "device_mode" : (val, prev)=>{
        this.calcTabContentScrollTop()
        this.calcTabContentBottom()
        this.calcTourDetailContentTop()
      }
    }
  }

  calcTabContentScrollTop(){
    if(this.$data.device_mode === "sp"){
      this.$data.tabContentScrollTop = this.$tourDetailContent.offset().top - Header.$el.height()
    }else{
      this.$data.tabContentScrollTop = this.$contactInformation.offset().top
    }
  }

  calcTabContentBottom(){
    this.$data.tabContentBottom = this.$data.tabContentScrollTop + this.tabContent.contentList[this.tabContent.$data.activeIndex].height()
  }

  calcTourDetailContentTop(){
    if(this.$data.device_mode === "sp"){
      this.$data.tourDetailContentTop = this.$tourDetailContent.offset().top - Header.$el.height()
    }else{
      this.$data.tourDetailContentTop = this.$tourDetailContent.offset().top
    }
  }

  async scrollTabContentHead(){
    // return new Promise((resolve, reject)=>{
      let tabContentScrollTop = this.$data.tabContentScrollTop
      let scrollTop = WindowScroll.scrollTop
      let diff = Math.abs(tabContentScrollTop - scrollTop)
      let duration = diff*0.5
      if(duration===0){
        duration = 10
      }else if(duration < 300){
        duration = 500
      }
      await WindowScroll.scrollTo({
        scrollTop: tabContentScrollTop,
        duration: duration,
        easing: "easeInOutQuart"
      })
    //   resolve()
    // })
  }

  mounted() {

    //お問い合わせ先
    this.$contactInformation = this.$el.find(".tourContactInformation")

    //コンテンツ詳細
    this.$tourDetailContent = this.$el.find("#tourDetail_content")

    //tabContent
    this.tabContent = new TabContent(document.querySelector("[data-comp='Detail'] [data-comp='TabContent']"))

    window.addEventListener("resize", ()=>{
      if(!this.tabContent.contentList[this.tabContent.$data.activeIndex]){
        return
      }
      this.calcTabContentScrollTop()
      this.calcTabContentBottom()
      this.calcTourDetailContentTop()
    })

    WindowScroll.addEventListener("scrollTop", (data)=>{
      //タブのナビ固定
      if(data.scrollTop > this.$data.tourDetailContentTop){
        this.tabContent.$data.navFixed = true
      }else{
        this.tabContent.$data.navFixed = false
      }
      //タブのナビ隠す
      if(data.scrollTop > this.$data.tabContentBottom){
        this.tabContent.$data.navHidden = true
      }else{
        this.tabContent.$data.navHidden = false
      }
    })

    this.tabContent.addEventListener("activeIndex", async (data)=>{
        await this.scrollTabContentHead()
    }, 0)

    this.tabContent.addEventListener("activeIndex", async (data)=>{
      this.calcTabContentBottom()
    })

    //基本情報スライドショー
    this.productSlideShow = new ProductImgSlideShow(document.querySelector("[data-comp='ProductImgSlideShow']"))


    //TourList
    this.tourList = new TourList(this.$el.find("#tourList"))
    this.$tourList = this.$el.find("#tourList")

    // 「その他のツアー一覧」ブロックは、予約/お申込みタブ選択時は表示しない
    const RESERVE_TAB_INDEX = 3

    // ページ遷移時、お申込みタブを表示していたら、「その他のツアー一覧」ブロックを隠す
    let initialActiveIndexFromOne = this.$el.find("[data-comp='TabContent']").data("initialActiveIndexFromOne")

    if (typeof initialActiveIndexFromOne !== 'undefined') {
      let initialActiveIndex = parseInt(initialActiveIndexFromOne) - 1

      if (initialActiveIndex === RESERVE_TAB_INDEX) {
        this.$tourList.hide()
      }
    }

    // タブ切替時、適宜「その他のツアー」の表示を切り替える
    this.tabContent.addEventListener("activeIndex", async (data)=>{
      if (data === RESERVE_TAB_INDEX) {
        this.$tourList.hide()
      } else {
        this.$tourList.show()
      }
    })

    //Devie
    this.$data.device_mode = Device.$data.device_mode
    Device.addEventListener("device_mode", (val)=>{
      this.$data.device_mode = val
    })
    //calc tab content size
    setTimeout(() => {
      this.calcTabContentScrollTop()
      this.calcTabContentBottom()
      this.calcTourDetailContentTop()
    }, 0);
  }
}

const detail = new Detail("[data-comp='Detail']")
export default detail
